import { Components, Theme } from "@mui/material"

export const MuiButton: Required<Components<Theme>>["MuiButton"] = {
  styleOverrides: {
    root: ({
      theme: {
        palette,
        typography,
        uisk: { spacing, radius },
      },
    }) => ({
      ...typography["Text sm/Semibold"],

      borderRadius: radius.full,
      flexGrow: 1,
      height: "28px",
      padding: [0, spacing.md],
      variants: [
        {
          props: { variant: "brand" },
          style: {
            color: palette["button-brand-fg"],
            backgroundColor: palette["button-brand-bg"],
            "&:hover": {
              color: palette["button-brand-fg_hover"],
              backgroundColor: palette["button-brand-bg_hover"],
            },
            "&.Mui-disabled": {
              color: palette["text-disabled"],
              backgroundColor: palette["bg-disabled"],
            },
          },
        },
        {
          props: { variant: "primary" },
          style: {
            color: palette["button-primary-fg"],
            backgroundColor: palette["button-primary-bg"],
            "&:hover": {
              color: palette["button-primary-fg_hover"],
              backgroundColor: palette["button-primary-bg_hover"],
            },
          },
        },
        {
          props: { variant: "outline" },
          // TODO (SU-82): UX to provide border hover colors
          style: {
            color: palette["text-brand-primary"],
            border: `1px solid ${palette["border-brand"]}`,
            "&hover:": {
              opacity: 0.65,
            },
          },
        },
        {
          props: { variant: "warning" },
          style: {
            color: palette["text-primary"],
            backgroundColor: palette["bg-warning-primary"],
            "&:hover": {
              color: palette["button-primary-fg_hover"],
              backgroundColor: palette["button-primary-bg"],
              border: palette["border-warning_subtle"],
            },
          },
        },
      ],
    }),
  },
}
